// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("Cell");

function make(cellData, onClick, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      if (cellData[/* value */0] === 1) {
        return React.createElement("span", {
                    className: "cell alive",
                    style: {
                      backgroundColor: cellData[/* color */1]
                    },
                    onClick: onClick
                  });
      } else {
        return React.createElement("span", {
                    className: "cell dead",
                    style: {
                      backgroundColor: cellData[/* color */1]
                    },
                    onClick: onClick
                  });
      }
    });
  return newrecord;
}

exports.component = component;
exports.make      = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/cell.re
// module id = 40
// module chunks = 0